<template>
  <q-form v-if="formData" ref="form" class="full-width q-px-md">
    <div class="row">
      <div class="col-12">
        <q-tabs v-model="tab">
          <q-tab name="general" label="General" />
          <q-tab name="address" label="Address Info" />
          <q-tab name="members" label="Members" />
          <q-tab name="teamManagement" label="User Management" />
        </q-tabs>
      </div>
    </div>
    <div class="row" v-if="tab == 'general'">
      <div class="col-12">
        <h6 class="q-my-none q-mt-xs">General</h6>
      </div>
      <div class="col-12" :class="{ 'col-md-8': formData.id }">
        <div class="row">
          <div class="col-12 col-md-6 q-pa-xs">
            <q-input
              v-model="formData.association_name"
              label="Association Name"
              :readonly="formData.external_uuid ? true : false"
              v-bind="siteCFG.fields.general"
            >
            </q-input>
          </div>
          <div class="col-12 col-md-3 q-pa-xs">
            <q-input
              label="Abbr"
              v-model="formData.association_abbr"
              v-bind="siteCFG.fields.general"
            >
            </q-input>
          </div>
          <div class="col-12 col-md-3 q-pa-xs">
          <q-input
            label="Code"
            v-model="formData.association_code"
            v-bind="siteCFG.fields.general"
          >
          </q-input>
        </div>
          <div class="col-12 col-md-6 q-pa-xs">
            <q-input
              v-model="formData.email"
              label="Email"
              v-bind="siteCFG.fields.general"
            >
              <template v-slot:prepend>
                <q-icon name="mdi-email" />
              </template>
            </q-input>
          </div>
          <div class="col-12 col-md-6 q-pa-xs">
            <q-input
              v-model="formData.website"
              label="Website"
              v-bind="siteCFG.fields.general"
            >
              <template v-slot:prepend>
                <q-icon name="mdi-earth" />
              </template>
            </q-input>
          </div>
          <div class="col-12 col-md-6 q-pa-xs">
            <q-input
              v-model="formData.phone"
              label="Phone"
              v-bind="siteCFG.fields.general"
            >
              <template v-slot:prepend>
                <q-icon name="mdi-phone" />
              </template>
            </q-input>
          </div>
          <div class="col-12 col-sm-6 col-md-3 q-pa-xs">
            <q-input
              v-model="formData.lat"
              label="Lat"
              v-bind="siteCFG.fields.general"
            >
            </q-input>
          </div>
          <div class="col-12 col-sm-6 col-md-3 q-pa-xs">
            <q-input
              v-model="formData.long"
              label="Long"
              v-bind="siteCFG.fields.general"
            >
            </q-input>
          </div>
          <div class="col-12 col-md-6 q-pa-xs">
            <q-select
              v-model="formData.region"
              label="Region"
              :options="associationRegions"
              v-bind="siteCFG.fields.general"
            >
            </q-select>
          </div>
          <div class="col-12 col-md-6 q-pa-xs">
            <q-select
              v-model="formData.area"
              label="Area"
              :options="associationAreas"
              v-bind="siteCFG.fields.general"
            >
            </q-select>
          </div>

          <div class="col-12 q-pa-xs">
            <q-input
              v-model="formData.xeroContact_id"
              label="Xero Contact ID"
              v-bind="siteCFG.fields.general"
            ></q-input>
          </div>
        </div>
      </div>
      <div v-if="formData.id" class="col-12 col-md-4">
        <div class="row">
          <div class="col-12">
            <div
              v-if="(changeImage || !formData.capUrl) && formData.id"
              style="margin: auto; width: 300px"
            >
              <croppa
                ref="imgCroppa"
                :height="200"
                :width="300"
                :show-remove-button="true"
                v-model="myCroppa"
                remove-button-color="#68c6d2"
                :show-loading="true"
                :loading-size="50"
                crossOrigin="anonymous"
                :quality="2"
                :prevent-white-space="false"
                :placeholder="'Choose an image (300x200)'"
                :placeholder-font-size="15"
              >
              </croppa>
              <q-btn
                class="full-width"
                color="negative"
                label="Cancel"
                @click="
                  changeImage = false;
                  myCroppa = null;
                "
                v-if="formData.id && formData.capUrl"
              >
              </q-btn>
            </div>
            <div v-else style="margin: auto; width: 300px">
              <q-img
                :src="formData.capUrl"
                style="height: 200px; width: 300px"
                v-if="formData.id"
              >
              </q-img>
              <q-btn
                class="full-width"
                color="primary"
                label="Change"
                @click="changeImage = true"
                v-if="formData.id"
              >
              </q-btn>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <h6 class="q-my-none q-mt-xs">Contact</h6>
      </div>
      <div class="col-12 col-md-6 q-pa-xs">
        <q-input
          v-model="formData.contactName"
          label="Contact"
          v-bind="siteCFG.fields.general"
        >
          <template v-slot:prepend>
            <q-icon name="mdi-account" />
          </template>
        </q-input>
      </div>
      <div class="col-12 col-md-6 q-pa-xs">
        <q-input
          label="Email"
          v-model="formData.contactEmail"
          v-bind="siteCFG.fields.general"
        >
          <template v-slot:prepend>
            <q-icon name="mdi-email" />
          </template>
        </q-input>
      </div>
      <div class="col-10 col-md-4 q-pa-xs">
        <q-input
          v-model="formData.contactPhone"
          label="Phone"
          v-bind="siteCFG.fields.general"
        >
          <template v-slot:prepend>
            <q-icon name="mdi-phone" />
          </template>
        </q-input>
      </div>
      <div class="col-2 col-md-21 q-pa-xs">
        <q-input
          v-model="formData.contactPhoneExt"
          label="Ext"
          v-bind="siteCFG.fields.general"
        >
        </q-input>
      </div>
      <div class="col-12 col-md-6 q-pa-xs">
        <q-input
          v-model="formData.contactMobile"
          label="Mobile"
          v-bind="siteCFG.fields.general"
        >
          <template v-slot:prepend>
            <q-icon name="mdi-cellphone" />
          </template>
        </q-input>
      </div>
      <div class="col-12">
        <h6 class="q-my-none q-mt-xs">Settings</h6>
      </div>
      <div class="col-12 col-sm-6 col-md-3 q-mt-md">
        <q-toggle
          indeterminate-value="not_answered"
          label="Enabled"
          :true-value="1"
          :false-value="0"
          v-model="formData.is_enabled"
        />
      </div>
      <div class="col-12 col-sm-6 col-md-3 q-mt-md">
        <q-toggle
          :true-value="1"
          :false-value="0"
          label="Manage Members"
          v-model="formData.manageMembers"
        />
      </div>
      <div class="col-12 col-sm-6 col-md-3 q-mt-md">
        <q-toggle
          :true-value="1"
          :false-value="0"
          label="Test Association"
          v-model="formData.testAssociation"
        />
      </div>
      <div class="col-12 col-sm-6 col-md-3">
        <q-input
          v-model="formData.external_uuid"
          label="Remote Sync ID"
          v-bind="siteCFG.fields.general"
          readonly
        >
        </q-input>
      </div>
    </div>
    <div class="row" v-if="tab == 'address'">
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <h6 class="q-my-none q-mt-xs">Address Info</h6>
          </div>

          <div class="col-12 col-sm-6 q-pa-xs">
            <div class="row">
              <div class="col-12">
                <p class="q-my-none q-mt-md formSubTitle">Physical Address</p>
              </div>
              <div class="col-12 q-py-xs">
                <q-input
                  v-model="formData.physicalAddress"
                  label="Address"
                  v-bind="siteCFG.fields.general"
                  :readonly="formData.external_uuid ? true : false"
                >
                </q-input>
              </div>
              <div class="col-12 q-py-xs">
                <q-input
                  v-model="formData.physicalSuburb"
                  label="Suburb"
                  v-bind="siteCFG.fields.general"
                  :readonly="formData.external_uuid ? true : false"
                >
                </q-input>
              </div>
              <div class="col-12 q-py-xs">
                <q-input
                  v-model="formData.physicalCity"
                  label="City"
                  v-bind="siteCFG.fields.general"
                  :readonly="formData.external_uuid ? true : false"
                >
                </q-input>
              </div>
              <div class="col-12 q-py-xs">
                <q-input
                  v-model="formData.physicalRegion"
                  label="Region"
                  v-bind="siteCFG.fields.general"
                >
                </q-input>
              </div>
              <div class="col-12 q-py-xs">
                <q-input
                  v-model="formData.physicalCountry"
                  label="Country"
                  v-bind="siteCFG.fields.general"
                >
                </q-input>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 q-pa-xs">
            <div class="row">
              <div class="col-12">
                <p class="q-my-none q-mt-md formSubTitle">Postal Address</p>
              </div>
              <div class="col-12 q-py-xs">
                <q-input
                  v-model="formData.postalAddress1"
                  label="Address 1"
                  v-bind="siteCFG.fields.general"
                >
                </q-input>
              </div>
              <div class="col-12 q-py-xs">
                <q-input
                  v-model="formData.postalAddress2"
                  label="Address 2"
                  v-bind="siteCFG.fields.general"
                >
                </q-input>
              </div>
              <div class="col-12 q-py-xs">
                <q-input
                  v-model="formData.postalAddress3"
                  label="Address 3"
                  v-bind="siteCFG.fields.general"
                >
                </q-input>
              </div>
              <div class="col-12 q-py-xs">
                <q-input
                  v-model="formData.postalPostCode"
                  label="Post Code"
                  v-bind="siteCFG.fields.general"
                  :readonly="formData.external_uuid ? true : false"
                >
                </q-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="tab == 'members'">
      <div class="col-12">
        <h6 class="q-my-none q-mt-xs">
          Members
          <q-btn
            v-if="!addMember"
            class="q-ml-md"
            color="primary"
            text-color="white"
            no-caps
            @click="addMember = true"
          >
            <q-icon
              name="mdi-plus-circle"
              color="white"
              class="q-mr-sm"
              size="xs"
            ></q-icon>
            Add
          </q-btn>

          <q-btn
            v-if="editMember || addMember"
            class="float-right"
            flat
            @click="
              $router.push(`/associations/${data.id}`);
              addMember = false;
            "
          >
            <q-icon name="mdi-close"></q-icon>
          </q-btn>
          <q-input
            v-if="!editMember && !addMember"
            style="max-width: 70%"
            filled
            class="float-right"
            v-model="membersSearch"
            debounce="200"
            label="Search"
            clearable
            dense
          >
            <template #prepend>
              <q-icon name="mdi-magnify"> </q-icon>
            </template>
          </q-input>
        </h6>
      </div>
      <div
        v-if="!editMember && !addMember"
        class="col-12"
        style="height: calc(100vh - 285px) !important"
      >
        <datatable
          :filter="membersSearch"
          :flat="true"
          :data="members"
          :columns="memberColumns"
          @rowDoubleClick="memberDoubleClick"
        >
          <template slot="body-cell-awards" slot-scope="data">
            <q-td :props="data.props">
              <q-icon name="mdi-file-certificate-outline" size="sm">
                <q-tooltip>
                  <div>
                    <div>Player Awards</div>
                    <div
                      v-if="data.props.row.awards.length > 0"
                      v-for="(award, index) in data.props.row.awards"
                      :key="`award_${index}`"
                    >
                      {{ award.shortName }}
                      {{
                        award.typeExpiry == 1 ? `- ${award.refresher_date}` : ""
                      }}
                    </div>
                    <div v-if="data.props.row.awards.length < 1">No Awards</div>
                  </div>
                </q-tooltip>
              </q-icon>
            </q-td>
          </template>
          <template slot="body-cell-actions" slot-scope="data">
            <q-td :props="data.props">
              <q-btn icon="mdi-trash-can-outline" color="negative" flat rounded dense size="md" :disable="data.props.row.isCRM" @click="removeMemberFromAssociation(data.props.row)">
                <q-tooltip>
                  <div>
                    <div>Remove Member from Association</div>
                  </div>
                </q-tooltip>
              </q-btn>
            </q-td>
          </template>
        </datatable>
      </div>
      <div v-if="addMember" class="col-12">
        <memberForm
          ref="addMemberForm"
          forAssociation
          addMember
          @close="
            $router.push(`/associations/${data.id}`);
            addMember = false;
          "
          @loadingStateChanged="(state) => (addMemberLoading = state)"
        />
      </div>
      <div v-if="addMember" class="col-12">
        <q-btn
          class="float-right"
          color="primary"
          text-color="white"
          no-caps
          :loading="addMemberLoading"
          @click="addMemberToAssociation"
        >
          <q-icon
            name="mdi-content-save"
            color="white"
            class="q-mr-sm"
            size="xs"
          ></q-icon>
          Add Member
        </q-btn>
      </div>
      <div v-if="editMember" class="col-12">
        <memberForm
          ref="editMemberForm"
          forCompetition
          for-association
          add-member
          :id="$route.params.member_id"
          @close="$router.push(`/associations/${data.id}`)"
          @loadingStateChanged="(state) => (editMemberLoading = state)"
        />
      </div>
      <div v-if="editMember" class="col-12">
        <q-btn
          class="float-right"
          color="primary"
          text-color="white"
          no-caps
          :loading="editMemberLoading"
          @click="saveMember"
        >
          <q-icon
            name="mdi-content-save"
            color="white"
            class="q-mr-sm"
            size="xs"
          ></q-icon>
          Save Member
        </q-btn>
      </div>
    </div>
    <div class="row" v-if="tab == 'teamManagement'">
      <div class="col-12">
        <h6 class="q-my-none q-mt-xs">
          User Management
          <q-btn
            v-if="!addUser && !editUser"
            class="q-ml-md"
            color="primary"
            text-color="white"
            no-caps
            @click="addUser = true"
          >
            <q-icon
              name="mdi-plus-circle"
              color="white"
              class="q-mr-sm"
              size="xs"
            ></q-icon>
            Add
          </q-btn>

          <q-btn
            v-if="addUser"
            class="float-right"
            flat
            @click="addUser = false"
          >
            <q-icon name="mdi-close"></q-icon>
          </q-btn>
          <q-btn
            v-if="editUser"
            class="float-right"
            flat
            @click="$router.push(`/associations/${data.id}`)"
          >
            <q-icon name="mdi-close"></q-icon>
          </q-btn>
          <q-input
            v-if="!addUser && !editUser"
            style="max-width: 70%"
            filled
            class="float-right"
            v-model="usersSearch"
            debounce="200"
            label="Search"
            clearable
            dense
          >
            <template #prepend>
              <q-icon name="mdi-magnify"> </q-icon>
            </template>
          </q-input>
        </h6>
      </div>
      <div
        v-if="!addUser && !editUser"
        class="col-12"
        style="height: calc(100vh - 285px) !important"
      >
        <datatable
          :filter="usersSearch"
          :flat="true"
          :data="users"
          :columns="userColumns"
          @rowDoubleClick="userDoubleClick"
        >
          <template slot="body-cell-actions" slot-scope="data">
            <q-td :props="data.props">
              <q-btn
                :loading="removingUserID == data.props.row.id"
                @click="removeUser(data.props.row.id)"
                round
                flat
                color="negative"
              >
                <q-icon name="mdi-trash-can-outline"></q-icon>
                <q-tooltip>Remove User</q-tooltip>
              </q-btn>
            </q-td>
          </template>
        </datatable>
      </div>
      <div v-if="addUser" class="col-12">
        <userForm
          ref="addUserForm"
          forAssociation
          @close="addUser = false"
          @loadingStateChanged="(state) => (addUserLoading = state)"
        />
      </div>

      <div v-if="addUser" class="col-12">
        <q-btn
          class="float-right"
          color="primary"
          text-color="white"
          no-caps
          :loading="addUserLoading"
          @click="submitUserToAdd"
        >
          <q-icon
            name="mdi-plus-circle"
            color="white"
            class="q-mr-sm"
            size="xs"
          ></q-icon>
          Add User
        </q-btn>
      </div>
      <div v-if="editUser" class="col-12">
        <userForm
          ref="editUserForm"
          forAssociation
          :id="$route.params.user_id"
          @close="$router.push(`/associations/${data.id}`)"
          @loadingStateChanged="(state) => (editUserLoading = state)"
        />
      </div>
      <div v-if="editUser" class="col-12">
        <q-btn
          class="float-right"
          color="primary"
          text-color="white"
          no-caps
          :loading="editUserLoading"
          v-if="!$route.params.userPermissions_id"
          @click="saveUser"
        >
          <q-icon
            name="mdi-content-save"
            color="white"
            class="q-mr-sm"
            size="xs"
          ></q-icon>
          Save User
        </q-btn>
      </div>
    </div>
  </q-form>
</template>

<script>
  import { mapGetters } from "vuex";
  import datatable from "@/components/datatable/datatable.vue";
  import memberForm from "@/components/users/memberForm.vue";
  import userForm from "@/components/users/userForm.vue";
  import moment from "moment";

  export default {
    components: { datatable, memberForm, userForm },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        siteCFG: "settings/siteCFG",
        data: "associations/current",
        dataLoading: "associations/currentLoading",
        members: "associations/members",
        membersLoading: "associations/membersLoading",
        users: "associations/users",
        usersLoading: "associations/usersLoading",
        divisions: "divisions/list",
        associationRegions: "associations/regions",
        associationAreas: "associations/areas",
      }),
      // Member
      memberColumns: function () {
        return [
          {
            name: "name",
            label: "Name",
            align: "left",
            field: (row) => row,
            format: (val) => `${val.firstName} ${val.lastName}`,
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "birthDate",
            label: "DOB",
            align: "left",
            field: "birthDate",
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

            sortable: true,
          },
          {
            name: "gender",
            label: "Gender",
            align: "left",
            field: "gender",
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

            sortable: true,
          },
          {
            name: "division",
            label: "Division",
            align: "left",
            field: "birthDate",
            format: (val, row) => {
              if (this.divisions) {
                let year = moment().format("YYYY");
                let reference = moment(`${year}-09-30`);
                if (moment(`${year}-07-01`) > moment()) {
                  reference = reference.subtract(1, "years");
                }
                let age = reference.diff(val, "years", false);
                let div = this.divisions.find(
                  (d) =>
                    d.division_age_min <= age &&
                    d.age_max >= age &&
                    row.gender == d.gender
                );
                return div ? div.division_name : "No Division";
              } else {
                return "";
              }
            },
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sort: (a, b, rowA, rowB) => {
              let year = moment().format("YYYY");
              let reference = moment(`${year}-09-30`);
              if (moment(`${year}-07-01`) > moment()) {
                reference = reference.subtract(1, "years");
              }

              let ageA = reference.diff(rowA.birthDate, "years", false);
              let ageB = reference.diff(rowB.birthDate, "years", false);

              if (ageA == ageB) {
                return rowA.gender.localeCompare(rowB.gender);
              } else {
                return ageA - ageB;
              }
            },

            sortable: true,
          },
          {
            name: "mobilePhone",
            label: "Mobile Phone",
            align: "left",
            field: "mobilePhone",
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

            sortable: true,
          },
          {
            name: "awards",
            label: "Awards",
            align: "left",
            field: "awards",
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

            sortable: true,
          },
          {
            name: "actions",
            label: "Actions",
            align: "right",
            sortable: false,
          },
        ];
      },
    },
    props: {
      id: {
        default: null,
      },
    },
    watch: {
      id: function () {
        this.init();
      },
      data: function () {
        this.init();
      },
      $route: function () {
        this.handleRoute();
      },
    },
    data: () => ({
      // Extra Data
      formData: null,
      tab: "general",

      // Croppa
      myCroppa: {},
      changeImage: false,

      membersSearch: "",
      removingMemberID: null,
      editMember: false,
      editMemberLoading: false,

      // Team Management
      userColumns: [
        {
          name: "id",
          label: "ID",
          align: "left",
          field: "id",
          sortable: true,
        },
        {
          name: "name",
          label: "Name",
          align: "left",
          field: "name",
          sortable: true,
        },
        {
          name: "email",
          label: "Email",
          align: "left",
          field: "email",
          sortable: true,
        },
        {
          name: "role",
          label: "Role",
          align: "left",
          field: "role",

          sortable: true,
        },
        {
          name: "created_at",
          label: "Created At",
          align: "left",
          field: "created_at",
          format: (val) =>
            val != null
              ? moment.utc(val).local().format("DD-MMM, YYYY h:mma")
              : "",
          sortable: true,
        },
        {
          name: "updated_at",
          label: "Updated At",
          align: "left",
          field: "updated_at",
          format: (val) =>
            val != null
              ? moment.utc(val).local().format("DD-MMM, YYYY h:mma")
              : "",
          sortable: true,
        },
        {
          name: "actions",
          label: "Actions",
          align: "left",
          sortable: false,
        },
      ],
      addUser: false,
      addUserLoading: false,
      usersSearch: "",
      removingUserID: null,
      editUser: false,
      editUserLoading: false,

      // Add NON CRM Members
      addMember: false,
      addMemberLoading: false,
    }),
    beforeCreate() {},
    mounted() {
      this.init();
      this.handleRoute();
      this.$store.dispatch("associations/loadByID", this.id);
      this.$store.dispatch("associations/loadMembersForAssociation", {
        id: this.id,
      });
      this.$store.dispatch("associations/loadUsers", this.id);
      this.$store.dispatch("divisions/loadAll");
    },
    methods: {
      init() {
        if (this.data != null && this.data.id == this.id) {
          this.formData = JSON.parse(JSON.stringify(this.data));
        } else {
          this.formData = {};
        }
      },
      handleRoute() {
        if (this.$route.params.member_id) {
          this.editMember = true;
        } else {
          this.editMember = false;
        }

        if (this.$route.params.user_id) {
          this.editUser = true;
        } else {
          this.editUser = false;
        }
      },
      create() {
        this.$emit("loadingStateChanged", true);
        this.$refs.form.validate().then((result) => {
          if (result) {
            this.$store
              .dispatch("associations/new", this.formData)
              .then((result) => {
                this.$emit("loadingStateChanged", false);
                if (result.Result == "Success") {
                  this.$emit("close", true);
                  this.formData = {};
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: result.Response.Message,
                  });
                } else {
                  this.$q.notify({
                    position: "top-right",
                    type: "negative",
                    message: result.Response.Message,
                  });
                }
              });
          } else {
            this.$emit("loadingStateChanged", false);
          }
        });
      },
      save() {
        this.$emit("loadingStateChanged", true);
        if (this.myCroppa && this.myCroppa.imageSet) {
          this.formData.image = {
            dataUrl: this.myCroppa.generateDataUrl(),
          };
        } else {
          delete this.formData.image;
        }

        this.$store
          .dispatch("associations/save", this.formData)
          .then((result) => {
            this.$emit("loadingStateChanged", false);
            if (result.Result == "Success") {
              this.$store.dispatch("associations/loadByID", this.id);
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: "The Association has been saved",
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      },

      // Members
      saveMember() {
        this.$refs.editMemberForm.save();
      },
      addMemberToAssociation() {
        this.$refs.addMemberForm.addMemberToAssociation();
      },
      memberDoubleClick(row) {
        this.$router.push(`/associations/${this.id}/members/${row.id}`);
      },

      // Users
      submitUserToAdd() {
        this.$refs.addUserForm.addUserAssociation(
          "Association",
          this.id,
          "associations/loadUsers"
        );
      },
      saveUser() {
        this.$refs.editMemberForm.save();
      },
      userDoubleClick(row) {
        this.$router.push(`/associations/${this.id}/users/${row.id}`);
      },
      removeUser(id) {
        this.removingUserID = id;
        this.$store
          .dispatch("associations/removeUser", {
            users_id: id,
            ref_id: this.id,
          })
          .then((result) => {
            if (result.Result == "Success") {
              this.address = "";
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      },
      removeMemberFromAssociation(row) {
        this.$swal({
          title: "Warning",
          text: "You are about to remove this member from the association, do you with to continue?",
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then((res) => {
          if (res.value) {
            this.$store
              .dispatch("associations/removeMember", {
                associations_id: this.formData.id,
                associationsMembers_id: row.id,
              })
              .then((result) => {
                if (result.Result == "Success") {
                  this.address = "";
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: result.Response.Message,
                  });
                } else {
                  this.$q.notify({
                    position: "top-right",
                    type: "negative",
                    message: "There was an Error, Please try again later",
                  });
                }
              });

          }
        });
      }

    },
  };
</script>

<style lang="scss" scoped>
  .formSubTitle {
    font-weight: bold;
  }
</style>
